import { defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { NotificationListDropdown, LanguageSelector } from '@hems/component';
import LabelButton from '@hems/user/src/components/button/LabelButton.vue';
import UserInfoButton from '@hems/user/src/components/button/UserInfoButton.vue';
import CIImage from '@hems/user/src/components/image/CIImage.vue';
import Navigation from '@hems/user/src/components/navigation/Navigation.vue';
import { useACDeviceType, useGenType } from '@hems/util';
import { DEFAULT_LANGUAGE } from '@hems/util/src/constant';
import { ACModuleNavigation, dashboardNavigation, energyManagementNavigation, getHomeApplianceNavigation, getReportNavigation, } from '@/config/navigation';
export default defineComponent({
    name: 'Header',
    components: {
        NotificationListDropdown,
        UserInfoButton,
        LabelButton,
        LanguageSelector,
        CIImage,
        Navigation,
    },
    props: {
        isExistUnrecognitionNotification: {
            type: Boolean,
            default: false,
        },
        notificationList: {
            type: Array,
            default: () => [],
        },
        hasHomeAppliance: {
            type: Boolean,
            default: false,
        },
    },
    emits: [
        'onOpenNotificationList',
        'updateNotificationRead',
        'onHomeInfo',
        'onLogout',
        'annualReportPopup',
        'onClickNavigation',
        'goHome',
    ],
    setup(props, { emit }) {
        const store = useStore();
        const { locale: i18nLocale, t } = useI18n();
        const notificationTabList = [{ text: t('common.notice'), value: 'NOTICE' }];
        const languageCode = ref(DEFAULT_LANGUAGE);
        const navigationItems = ref([]);
        const { isACSystem } = useGenType();
        const { hasACCombiner } = useACDeviceType();
        const { hasPV, hasESS } = store.state.device.siteConfiguration ?? { hasPV: true, hasESS: true };
        const filterNavigation = () => {
            const isConsumptionCT = store.state.device.isConsumptionCT;
            const isACModule = isACSystem && hasACCombiner;
            if (isACModule) {
                return [
                    dashboardNavigation,
                    getReportNavigation(hasPV, hasESS, isConsumptionCT),
                    ACModuleNavigation,
                    energyManagementNavigation,
                    getHomeApplianceNavigation(props.hasHomeAppliance),
                ];
            }
            if (isACSystem) {
                return [
                    dashboardNavigation,
                    getReportNavigation(hasPV, hasESS, isConsumptionCT),
                    energyManagementNavigation,
                    getHomeApplianceNavigation(props.hasHomeAppliance),
                ];
            }
            return [
                dashboardNavigation,
                getReportNavigation(hasPV, hasESS, isConsumptionCT),
                getHomeApplianceNavigation(props.hasHomeAppliance),
            ];
        };
        const onClickNavigation = (e, path) => {
            emit('onClickNavigation', e, path);
        };
        const onChangeLanguage = () => {
            i18nLocale.value = languageCode.value;
            store.dispatch('appCtx/setLangCd', languageCode.value);
            store.dispatch('appCtx/setLocale', languageCode.value);
        };
        navigationItems.value = filterNavigation();
        return {
            notificationTabList,
            languageCode,
            navigationItems,
            onClickNavigation,
            onChangeLanguage,
        };
    },
});
